// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dZzT","colBig":"styles_colBig__YpA8D","colSmall":"styles_colSmall__1lpdb"};